import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-ink-600 bg-ink-900"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img
            src="/um-logo.png"
            alt="Underground Mix"
            className="h-28 w-auto object-contain"
          />
          <p className="mt-4 text-white/60 text-sm max-w-sm leading-relaxed">
            A premium sync licensing community for indie songwriters, artists
            and producers. Founded by Devon &amp; Becki DeVries.
          </p>
          <div
            data-testid="footer-social"
            className="mt-6 flex items-center gap-3"
          >
            <a
              href="https://www.instagram.com/underground.mix/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Underground Mix on Instagram"
              data-testid="footer-instagram"
              className="h-10 w-10 flex items-center justify-center border border-ink-600 text-white/70 hover:text-black hover:bg-amber hover:border-amber transition-colors rounded-sm"
            >
              <Instagram size={18} />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61568719539572"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Underground Mix on Facebook"
              data-testid="footer-facebook"
              className="h-10 w-10 flex items-center justify-center border border-ink-600 text-white/70 hover:text-black hover:bg-amber hover:border-amber transition-colors rounded-sm"
            >
              <Facebook size={18} />
            </a>
            <a
              href="https://www.youtube.com/@undergroundmixsync"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Underground Mix on YouTube"
              data-testid="footer-youtube"
              className="h-10 px-3 flex items-center gap-2 border border-ink-600 text-white/70 hover:text-black hover:bg-amber hover:border-amber transition-colors rounded-sm font-mono text-[10px] uppercase tracking-widest"
            >
              <span>YouTube</span>
            </a>
          </div>
        </div>
        <div className="md:col-span-3">
          <h4 className="tag-kicker mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li>
              <Link to="/" className="hover:text-amber">
                Home
              </Link>
            </li>
            <li>
              <Link to="/access" className="hover:text-amber">
                Underground Access
              </Link>
            </li>
            <li>
              <Link to="/mastermind" className="hover:text-amber">
                Mastermind
              </Link>
            </li>
            <li>
              <Link to="/camp" className="hover:text-amber">
                UM C.A.M.P.
              </Link>
            </li>
            <li>
              <Link to="/course" className="hover:text-amber">
                The SYNC Immersion
              </Link>
            </li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <h4 className="tag-kicker mb-4">Resources</h4>
          <ul className="space-y-2 text-sm text-white/70 mb-6">
            <li>
              <Link
                to="/ebook"
                data-testid="footer-ebook-link"
                className="hover:text-amber"
              >
                Free · Survival Guide for Sync
              </Link>
            </li>
          </ul>
          <p className="text-sm text-white/60 mb-4">
            The premium sync community for indie artists. No fluff. No false
            promises. Just work.
          </p>
          <Link
            to="/access"
            data-testid="footer-cta-join"
            className="inline-block bg-amber hover:bg-amber-hover text-black font-bold uppercase tracking-wider text-xs px-6 py-3 rounded-sm transition-colors"
          >
            Join the Community
          </Link>
        </div>
      </div>

      <div className="border-t border-ink-600">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40 font-mono tracking-widest uppercase">
            © {new Date().getFullYear()} Underground Mix · The Bus Music
          </p>
          <p className="text-xs text-white/40 font-mono">
            Indie sync · <span className="text-amber">done right.</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
